import { render, staticRenderFns } from "./PageModule.vue?vue&type=template&id=b4e5ee54&scoped=true&"
import script from "./PageModule.vue?vue&type=script&lang=js&"
export * from "./PageModule.vue?vue&type=script&lang=js&"
import style0 from "./PageModule.vue?vue&type=style&index=0&id=b4e5ee54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e5ee54",
  null
  
)

export default component.exports